// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ogPYQ","addWidgetButton":"Header_addWidgetButton__3IpZF","dashboardTabs":"Header_dashboardTabs__4eYqj","active":"Header_active__29Rfn"};